var map = {
	"./arg.svg": 2326,
	"./aus.svg": 2327,
	"./bel.svg": 2328,
	"./bra.svg": 2329,
	"./can.svg": 2330,
	"./cmr.svg": 2331,
	"./crc.svg": 2332,
	"./cro.svg": 2333,
	"./den.svg": 2334,
	"./ecu.svg": 2335,
	"./eng.svg": 2336,
	"./esp.svg": 2337,
	"./fra.svg": 2338,
	"./ger.svg": 2339,
	"./gha.svg": 2340,
	"./irn.svg": 2341,
	"./jpn.svg": 2342,
	"./kor.svg": 2343,
	"./ksa.svg": 2344,
	"./mar.svg": 2345,
	"./mex.svg": 2346,
	"./ned.svg": 2347,
	"./pol.svg": 2348,
	"./por.svg": 2349,
	"./qat.svg": 2350,
	"./sen.svg": 2351,
	"./srb.svg": 2352,
	"./sui.svg": 2353,
	"./tun.svg": 2354,
	"./uru.svg": 2355,
	"./usa.svg": 2356,
	"./wal.svg": 2357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128;